import { PathElement } from './path-element.ts';
import { MatchingContext } from '../path-pattern.ts';

/*internal*/ export class SeparatorPathElement extends PathElement {
    constructor(pos: number, separator: number) {
        super(pos, separator);
    }

    matches(pathIndex: number, matchingContext: MatchingContext): boolean {
        if (pathIndex < matchingContext.pathLength && matchingContext.isSeparator(pathIndex)) {
            if (this.noMorePattern()) {
                if (matchingContext.determinedRemainingPath) {
                    matchingContext.remainingPathIndex = pathIndex + 1;
                    return true;
                }
                else {
                    return (pathIndex + 1 === matchingContext.pathLength);
                }
            }
            else {
                pathIndex++;
                return (this.next !== undefined && this.next.matches(pathIndex, matchingContext));
            }
        }
        return false;
    }

    get normalizedLength() {
        return 1;
    }

    get chars(): Uint16Array {
        return new Uint16Array([this.separator]);
    }

    get literal() {
        return true;
    }

    toString() {
        return `Separator(${String.fromCharCode(this.separator)})`;
    }
}
